export default "__VITE_ASSET__DGqFA2f2__"